const safeParseAdditional = (additional) => {
  if (!additional) return {};
  if (typeof additional === "object") return additional;

  try {
    return JSON.parse(additional);
  } catch (error) {
    return {};
  }
};

const getDuration = (additional) => {
  return safeParseAdditional(additional)?.duration?.toString() || "0";
};

const formatTime = (value) => {
  if (!value) return "";

  return new Date(value).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const transformCustomerData = (customerData) => {
  if (!customerData || typeof customerData !== "object") return [];

  return Object.entries(customerData).map(([customerName, bookings], index) => ({
    id: index + 1,
    isPrimary: index === 0,
    name: customerName,
    displayName: `Guest ${index + 1}`,
    customerName: "",
    services: (bookings || []).map((item, serviceIndex) => ({
      price_rate: item.price_rate,
      name: item.service_name,
      price: item.price,
      member_price: item.price_rate?.memberPrice,
      description: item.service_description || "",
      duration: getDuration(item.additional),
      status: 1,
      id: item.service_id,
      image: item.service_image || "",
      count: serviceIndex + 1,
      ...(item.addons?.length > 0 && {
        selectedAddons: item.addons.map((addon) => ({
          id: addon.id,
          name: addon.name,
          price_rate: addon.price_rate,
        })),
      }),
      ...(item.therapist_id && {
        therapistData: {
          id: item.therapist_id,
          therapist_id: item.therapist_id,
          alias: item.therapist_alias || item.therapist_name,
          name: item.therapist_name,
          pager_number: item.therapist_pager_number,
          gender: item.therapist_gender,
          requested: safeParseAdditional(item.additional)?.requested_person ? true : false,
        },
      }),
      startTime: formatTime(item.room_items?.[0]?.service_at),
      endTime: formatTime(item.room_items?.[0]?.service_end),
    })),
  }));
};
